import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
//import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
//import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import "../Codes/style/tableVoucherTransfersWeb.css"
//import moment from 'moment';
import { isMobile } from 'react-device-detect';
import PrintIcon from '@material-ui/icons/Print';

const useStyles = makeStyles(theme => ({
    logo: {
        width: '80%',
    },
    logoallwidth: {
        [theme.breakpoints.up('xs')]: {
            width: '120%',
            maxWidth: '342px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            maxWidth: '342px'
        },
        [theme.breakpoints.up('md')]: {
            width: '80%',
            maxWidth: '400px'
        },
        [theme.breakpoints.up('lg')]: {
            width: '60%',
            maxWidth: '400px'
        },
        [theme.breakpoints.up('xl')]: {
            width: '60%',
            maxWidth: '400px'
        },
    },
    textocabecera: {
        color: '#000000',
        fontSize: '180%',

        fontWeight: 'bold'
    },
    textovalor: {
        color: '#1a1919',
        fontSize: '350%',
        textAlign: "left",

        fontWeight: 'bold'
    },
    textovalorreduce: {
        color: '#1a1919',
        fontSize: '200%',
        textAlign: "left",

        fontWeight: 'bold'
    },
    textotitulodetalle: {
        // color: '#1a1919',
        fontSize: '100%',
        maxWidth: '100%',
        //fontFamily: 'MyriadPro-Regular'
    },
    textotitulodetallenegrita: {
        color: '#b48518',
        fontSize: '100%',
        //fontFamily: 'MyriadPro-Bold'
    },
    texttitleone: {
        // color: '#1a1919',
        fontSize: '100%',
        //fontFamily: 'MyriadPro-Bold'
    },
    line: {
        backgroundColor: '#009aa8',
        height: '1px',
        width: '100%'
    },
    fondotexto: {
        backgroundColor: 'white'
    },
    submit: {
        backgroundColor: '#2E2757',
        color: '#FFFFFF',
        borderRadius: '8px',
        //fontFamily: 'MyriadPro-Bold',
        fontSize: '1rem',
        "&:hover": {
            backgroundColor: "#09395e",
            color: "#FFFFFF",
        },
        [theme.breakpoints.up('xs')]: {
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('sm')]: {
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('md')]: {
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('lg')]: {
            fontWeight: 'bold'
        },
        [theme.breakpoints.up('xl')]: {
            fontWeight: 'bold'
        },
    },
    fondoTop: {
        backgroundColor: '#2E2757',
        borderBottom: '20px solid #b48518',
        minHeight: '180px'
    },
    fondoBottom: {
        //backgroundImage: `url(${process.env.PUBLIC_URL + '/images/fondo_voucher_web.png'})`,
        [theme.breakpoints.up('xs')]: {
            backgroundSize: '700%',
        },
        [theme.breakpoints.up('sm')]: {
            backgroundSize: '500%',
        },
        [theme.breakpoints.up('md')]: {
            backgroundSize: '135%',
        },
        [theme.breakpoints.up('lg')]: {
            backgroundSize: '135%',
        },
        [theme.breakpoints.up('xl')]: {
            backgroundSize: '135%',
        },
    },
    buttons: {
        marginBottom: '25px'
    },
    imageButton: {
        width: '20%',
        marginRight: '5px'
    },
    logoHeader: {
        maxWidth: '100%',
        height: '50%',
        padding: '0',
        margin: '0'
    },
    buttonTwo: {
        [theme.breakpoints.up('xs')]: {
            marginTop: '10px'
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: '10px'
        },
        [theme.breakpoints.up('md')]: {
            marginTop: '10px'
        },
        [theme.breakpoints.up('lg')]: {
            marginTop: '0px'
        },
        [theme.breakpoints.up('xl')]: {
            marginTop: '0px'
        },
    },
}));

const VoucherPaymentWeb = props => {

    const classes = useStyles();

    const {

        monto,
        title,

        handleDownloadVoucher,
        handleDownloadDevice,

        databodyone,
        databodytwo,
        titleone,
        titletwo,
        viewVoucher
    } = props;
    //console.log('viewVoucher', { viewVoucher })

    return (
        <div style={{ marginTop: '1%', marginLeft: '3%', marginRight: '3%' }}>
            <Grid container>
                <Grid item xs={12} className={classes.fondoTop} container justifyContent="center">
                    {
                        viewVoucher ?
                            <><Grid item xs={12} md={6} style={{ padding: '10px',alignContent:"center" }} container justifyContent="center">
                                    <img src={process.env.PUBLIC_URL + '/images/logo_voucher.png'} alt="Logo" className={classes.logoHeader} />
                            </Grid>
                                <Grid item xs={12} md={6} style={{ padding: '10px', color: '#FFFFFF' }} container justifyContent="center">
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="body2" align="center" >Valor cancelado</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h3" align="center" >$ {parseFloat(monto).toFixed(2)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h5" align="center" >COMPROBANTE DIGITAL DE {title}</Typography>
                                    </Grid>
                                </Grid></>
                            :
                            <><Grid item xs={12} md={6} style={{ padding: '10px',alignContent:"center" }} container justifyContent="center">
                                    <img src={process.env.PUBLIC_URL + '/images/logo_voucher.png'} alt="Logo" className={classes.logoHeader} />
                            </Grid>
                                <Grid item xs={12} style={{ padding: '10px', color: '#FFFFFF' }} container justifyContent="center">
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="body2" align="center" >Valor cancelado</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h3" align="center" >$ {parseFloat(monto).toFixed(2)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant="h5" align="center" >COMPROBANTE DIGITAL DE {title}</Typography>
                                    </Grid>
                                </Grid></>
                    }
                </Grid>
                <Grid item xs={12} className={classes.fondoBottom} container justifyContent="center">
                    <Grid item xs={12} md={10} style={{
                        marginTop: '20px', marginBottom: '20px'/* , backgroundColor: '#FFFFFF' */, padding: isMobile ? 0 : '20px'
                    }}>
                        {
                            (titleone.length > 0) &&
                            <Typography component="h3" variant="h6" align="justify">
                                <b className={classes.texttitleone}>{titleone}</b>
                            </Typography>
                        }
                        {
                            databodyone.map(row => (
                                <div key={row.order}>
                                    <Typography component="h3" variant="h6" className={classes.textotitulodetalle} align="justify">
                                        <b className={classes.textotitulodetallenegrita}>{row.title}:</b> {row.value}
                                    </Typography>
                                </div>
                            ))
                        }
                        {(databodytwo.length > 0) && <br />}
                        {
                            (titletwo.length > 0) &&
                            <Typography component="h3" variant="h6" align="justify">
                                <b className={classes.texttitleone}>{titletwo}</b>
                            </Typography>
                        }
                        {
                            databodytwo.map(row => (
                                <div key={row.order}>
                                    <Typography component="h3" variant="h6" className={classes.textotitulodetalle} align="justify">
                                        <b className={classes.textotitulodetallenegrita}>{row.title}:</b> {row.value}
                                    </Typography>
                                </div>

                            ))
                        }
                    </Grid>
                    <Grid item xs={8} container justifyContent='center' className={classes.buttons}>
                        {(!isMobile) ?
                            <>
                                <Grid item xs={12} lg={12} container justifyContent='center'>
                                    <Button
                                        /* size="small" */
                                        onClick={handleDownloadVoucher}
                                        variant="contained"
                                        className={classes.submit}
                                        startIcon={<PrintIcon />}
                                    >{/* <img src={process.env.PUBLIC_URL + '/images/nueva_transferencia.png'} 
                                    alt="Logo" 
                                    className={classes.imageButton} /> */}IMPRIMIR</Button>
                                </Grid>
                                {/* <Grid item xs={12} lg={6} container justifyContent='center' className={classes.buttonTwo}>
                                    <Button
                                        onClick={handleDownloadVoucher}
                                        variant="contained"
                                        className={classes.submit}
                                    > <img src={process.env.PUBLIC_URL + '/images/reenviar_comprobante.png'} 
                                    alt="Logo" 
                                    className={classes.imageButton} /> REENVIAR COMPROBANTE</Button>
                                </Grid> */}</>
                        
                        :
                            <Grid item xs={12} md={6} sm={6}>
                                <Button
                                    size="small"
                                    fullWidth
                                    onClick={handleDownloadDevice}
                                    variant="contained"
                                    className={classes.submit}
                                > Compartir</Button>
                                {/* <Button
                                        size="small"
                                        fullWidth
                                        onClick={handleDownloadVoucher}
                                        variant="contained"
                                        className={classes.submit}
                                        startIcon={<PrintIcon />}
                                    >IMPRIMIR</Button> */}
                            </Grid>
                        }
                    </Grid>
                    {/*
                        viewVoucher ?
                            <><Grid item xs={8} md={5} container alignItems='center' justifyContent='center'>
                                <Typography
                                    variant="h5"
                                    align="center"
                                    style={{
                                        marginBottom: '15px',
                                        color: '#025c98',
                                        //fontFamily: 'Roboto-Medium'
                                    }}>"Haciendo finanzas inclusivas"</Typography>
                            </Grid>
                                <Grid item xs={8} md={5} container alignItems='center' justifyContent='center'>
                                    <img src={process.env.PUBLIC_URL + '/images/footer_voucher_web.png'} alt="Logo" className={classes.logoallwidth} />
                                </Grid>
                            </>
                            :
                            <><Grid item xs={8} container alignItems='center' justifyContent='center'>
                                <Typography
                                    variant="h5"
                                    align="center"
                                    style={{
                                        marginBottom: '15px',
                                        color: '#025c98',
                                        //fontFamily: 'Roboto-Medium'
                                    }}>"Haciendo finanzas inclusivas"</Typography>
                            </Grid>
                                <Grid item xs={8} container alignItems='center' justifyContent='center'>
                                    <img src={process.env.PUBLIC_URL + '/images/footer_voucher_web.png'} alt="Logo" className={classes.logoallwidth} />
                                </Grid>
                            </>
                                */}

                </Grid>
            </Grid>
        </div>
    );
}



export default VoucherPaymentWeb;